export default __webpack_public_path__ + "static/media/assetTradeIcon2.a23c2f36.webp";